export default "__VITE_ASSET__x9MTJDwU__"